import React from 'react';
import { kpiVisualizationApi } from 'api/reports';
import { Card } from 'antd';
import Line from 'components/Chart/LineChart';
import useCharts from 'customHooks/useCharts';
import ChartTitle from '../../../shared/ChartTitle';

function TransactionCount() {
  const { data, loading, startDate, endDate } = useCharts({ callApi: kpiVisualizationApi.getTransactionCount });

  return (
    <Card className="rounded-2xl">
      <ChartTitle title="Transaction Count" startDate={startDate} endDate={endDate} />
      <Line
        data={data}
        dataKey="period"
        loading={loading}
        xLabel="Transaction Date"
        yLabel="Transaction Count"
        lines={[
          { type: 'linear', dataKey: 'transfer_count', stroke: '#DB5555', withLabelList: false },
          { type: 'linear', dataKey: 'recharge_count', stroke: '#009696', withLabelList: false },
        ]}
        legendOptions={{ visible: true }}
      />
    </Card>
  );
}

export default TransactionCount;
